module.exports = __webpack_public_path__ + "static/media/leftArrow.59012cde.svg";